(() => {
  window.S23GarmentPreview = function(host) {
    const canvas=host.querySelector('.s23-garment-canvas'), ctx=canvas.getContext('2d');
    const status=host.querySelector('.s23-mockup-status'), viewer=host.querySelector('.s23-mockup-viewer');
    const size=1800, cache=new Map(), pending=new Map();
    canvas.width=canvas.height=size;
    const art=document.createElement('canvas');art.width=art.height=size;
    const artCtx=art.getContext('2d',{willReadFrequently:true});
    let ready=false, revision=0;
    const selected=s=>host.querySelector(s+'[aria-pressed="true"]');
    function label() {
      const garment=selected('[data-aop-garment]'), color=selected('[data-aop-color]');
      const text=garment.querySelector('strong').textContent+' · '+color.querySelector('small').textContent;
      host.querySelector('.s23-aop-selection').textContent=text;
      canvas.setAttribute('aria-label',text+' — '+viewer.dataset.front);
      const purchase=host.querySelector('.s23-aop-purchase');
      host.querySelectorAll('.s23-size-grid input').forEach(input=>{
        const unavailable=garment.dataset.aopGarment==='tank'&&input.value==='2XL';
        if(unavailable&&input.checked){input.checked=false;host.querySelector('.s23-size-status').textContent=purchase.dataset.sizePrompt;}
        input.disabled=unavailable;input.closest('label').hidden=unavailable;
      });
      if(host.dataset.couples!=='true'){host.querySelector('.s23-aop-price').textContent=garment.dataset.price;host.querySelector('.s23-price-note').textContent=garment.dataset.priceNote;}
    }
    function load(url) {
      return new Promise((resolve,reject)=>{const img=new Image();img.crossOrigin='anonymous';img.onload=()=>resolve(img);img.onerror=reject;img.src=url;});
    }
    async function prepare(key) {
      if(cache.has(key))return cache.get(key);
      if(pending.has(key))return pending.get(key);
      const promise=(async()=>{
        const el=host.querySelector('[data-mockup="'+key+'"]');
        const [blank,detail]=await Promise.all([load(el.dataset.blank),load(el.dataset.detail)]);
        const work=document.createElement('canvas');work.width=work.height=size;
        const wc=work.getContext('2d',{willReadFrequently:true});
        wc.drawImage(blank,0,0,size,size);const base=wc.getImageData(0,0,size,size);
        wc.clearRect(0,0,size,size);wc.drawImage(detail,0,0,size,size);const ref=wc.getImageData(0,0,size,size).data;
        const alpha=new Uint8Array(size*size), trim=new Float32Array(size*size);
        for(let p=0;p<alpha.length;p++)alpha[p]=base.data[p*4+3]>220&&(!['pants','shortset','shorttop'].includes(key)||ref[p*4+3]>220)?1:0;
        const visited=new Uint8Array(alpha.length), queue=new Int32Array(alpha.length);let largest=[];const setParts=[];
        for(let p=0;p<alpha.length;p++){
          if(!alpha[p]||visited[p])continue;
          let head=0,tail=1;queue[0]=p;visited[p]=1;
          while(head<tail){const v=queue[head++],x=v%size;for(const n of [x>0?v-1:-1,x<size-1?v+1:-1,v-size,v+size])if(n>=0&&n<alpha.length&&alpha[n]&&!visited[n]){visited[n]=1;queue[tail++]=n;}}
          if(tail>largest.length)largest=queue.slice(0,tail);
          if(key==='shortset'&&tail>size*size*0.015)setParts.push(queue.slice(0,tail));
        }
        const solid=new Uint8Array(alpha.length);for(const part of (key==='shortset'?setParts:[largest]))for(const p of part)solid[p]=1;
        for(let p=0;p<alpha.length;p++){
          const i=p*4,x=p%size,y=Math.floor(p/size);
          let a=0;
          if(x>1&&y>1&&x<size-2&&y<size-2&&solid[p]&&solid[p-2]&&solid[p+2]&&solid[p-2*size]&&solid[p+2*size])a=255;
          base.data[i+3]=a;
          const r=ref[i],g=ref[i+1],b=ref[i+2],hi=Math.max(r,g,b),lo=Math.min(r,g,b);
          trim[p]=ref[i+3]>220&&hi>130?Math.max(0,Math.min(1,(0.14-(hi-lo)/Math.max(hi,1))/0.07)):0;
        }
        const value={base,trim};cache.set(key,value);while(cache.size>2)cache.delete(cache.keys().next().value);return value;
      })();pending.set(key,promise);
      try{return await promise;}finally{pending.delete(key);}
    }
    async function render() {
      label();if(!ready)return;
      const version=++revision,key=selected('[data-aop-garment]').dataset.aopGarment;
      canvas.hidden=true;openButton.hidden=true;status.hidden=false;status.textContent=viewer.dataset.loading;
      try {
        const pieces=key==='pajama'?['pajama','pants']:[key];
        const prepared=await Promise.all(pieces.map(prepare));
        if(version!==revision)return;
        const pixels=artCtx.getImageData(0,0,size,size).data,out=ctx.createImageData(size,size);
        const hex=selected('[data-aop-color]').dataset.hex.slice(1);
        const collarColor=[0,2,4].map(start=>parseInt(hex.slice(start,start+2),16));
        const rendered=prepared.map(({base,trim},pieceIndex)=>{
        out.data.fill(0);
        for(let p=0;p<trim.length;p++){
          const i=p*4,a=base.data[i+3];if(!a)continue;
          const lum=(base.data[i]+base.data[i+1]+base.data[i+2])/3;
          const shade=Math.pow(lum/246,1.8),highlight=Math.max(0,lum-224)*0.22,t=trim[p];
          for(let c=0;c<3;c++){
            const trimColor=key==='tee'?collarColor[c]*shade+highlight:base.data[i+c];
            out.data[i+c]=(pixels[i+c]*shade+highlight)*(1-t)+trimColor*t;
          }
          out.data[i+3]=a;
        }
        const layer=document.createElement('canvas');layer.width=layer.height=size;layer.getContext('2d').putImageData(out,0,0);return layer;
        });
        ctx.clearRect(0,0,size,size);
        if(key==='pajama'){const ratio=size/900;ctx.drawImage(rendered[0],0,120*ratio,550*ratio,550*ratio);ctx.drawImage(rendered[1],300*ratio,30*ratio,820*ratio,820*ratio);}else{ctx.drawImage(rendered[0],0,0);}
        canvas.hidden=false;status.hidden=true;openButton.hidden=false;if(dialog.open)copyPreview();
        canvas.dataset.garment=key;canvas.dataset.color=selected('[data-aop-color]').dataset.aopColor;
        canvas.dataset.revision=String(version);
      }catch(e){if(version!==revision)return;canvas.hidden=true;status.hidden=false;status.textContent=viewer.dataset.error;}
    }
    async function matchingPreview(target, source, hex) {
      const {base,trim}=await prepare('tee');
      const work=document.createElement('canvas');work.width=work.height=size;
      const wc=work.getContext('2d',{willReadFrequently:true});wc.drawImage(source,0,0,size,size);
      const pixels=wc.getImageData(0,0,size,size).data,out=wc.createImageData(size,size);
      const collar=[0,2,4].map(start=>parseInt(hex.slice(1+start,3+start),16));
      for(let p=0;p<trim.length;p++){
        const i=p*4,a=base.data[i+3];if(!a)continue;
        const lum=(base.data[i]+base.data[i+1]+base.data[i+2])/3;
        const shade=Math.pow(lum/246,1.8),highlight=Math.max(0,lum-224)*.22,t=trim[p];
        for(let c=0;c<3;c++)out.data[i+c]=(pixels[i+c]*shade+highlight)*(1-t)+(collar[c]*shade+highlight)*t;
        out.data[i+3]=a;
      }
      wc.putImageData(out,0,0);
      const context=target.getContext('2d');context.clearRect(0,0,target.width,target.height);
      context.drawImage(work,0,0,target.width,target.height);work.width=work.height=1;
    }
    const openButton=viewer.querySelector('.s23-preview-open');
    const dialog=viewer.querySelector('.s23-preview-dialog');
    const viewport=dialog.querySelector('.s23-zoom-viewport');
    const zoomCanvas=dialog.querySelector('canvas');
    const output=dialog.querySelector('output');
    let scale=1,offsetX=0,offsetY=0,previousFocus=null,previousOverflow='',gesture=null;
    const pointers=new Map();
    function applyZoom(){
      const box=viewport.getBoundingClientRect(), side=Math.min(box.width,box.height);
      const maxX=Math.max(0,(side*scale-box.width)/2),maxY=Math.max(0,(side*scale-box.height)/2);
      offsetX=Math.max(-maxX,Math.min(maxX,offsetX));offsetY=Math.max(-maxY,Math.min(maxY,offsetY));
      zoomCanvas.style.width=side+'px';zoomCanvas.style.height=side+'px';
      zoomCanvas.style.transform='translate('+offsetX+'px,'+offsetY+'px) scale('+scale+')';
      output.textContent=Math.round(scale*100)+'%';
    }
    function copyPreview(){zoomCanvas.width=canvas.width;zoomCanvas.height=canvas.height;zoomCanvas.getContext('2d').drawImage(canvas,0,0);zoomCanvas.setAttribute('aria-label',canvas.getAttribute('aria-label'));}
    function openPreview(){
      if(canvas.hidden||dialog.open)return;
      previousFocus=document.activeElement;previousOverflow=document.body.style.overflow;
      copyPreview();dialog.showModal();document.body.style.overflow='hidden';scale=1;offsetX=offsetY=0;
      requestAnimationFrame(applyZoom);
    }
    function closePreview(){dialog.close();}
    openButton.addEventListener('click',openPreview);
    canvas.addEventListener('click',openPreview);
    canvas.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();openPreview();}});
    dialog.querySelector('[data-zoom-close]').addEventListener('click',closePreview);
    dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;pointers.clear();gesture=null;previousFocus?.focus({preventScroll:true});});
    dialog.querySelectorAll('[data-zoom]').forEach(button=>button.addEventListener('click',()=>{
      if(button.dataset.zoom==='reset'){scale=1;offsetX=offsetY=0;}else scale=Math.max(1,Math.min(4,scale*(button.dataset.zoom==='in'?1.4:1/1.4)));applyZoom();
    }));
    function measure(){const points=[...pointers.values()];if(points.length<2)return points[0]?{x:points[0].x,y:points[0].y,d:0}:null;return{x:(points[0].x+points[1].x)/2,y:(points[0].y+points[1].y)/2,d:Math.hypot(points[0].x-points[1].x,points[0].y-points[1].y)};}
    viewport.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button!==0)return;pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});viewport.setPointerCapture(e.pointerId);gesture=measure();});
    viewport.addEventListener('pointermove',e=>{
      if(!pointers.has(e.pointerId))return;e.preventDefault();pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});const next=measure();
      if(gesture){const box=viewport.getBoundingClientRect();const old=scale;if(next.d&&gesture.d)scale=Math.max(1,Math.min(4,scale*next.d/gesture.d));const ratio=scale/old;
      offsetX=next.x-box.left-box.width/2-(gesture.x-box.left-box.width/2-offsetX)*ratio;
      offsetY=next.y-box.top-box.height/2-(gesture.y-box.top-box.height/2-offsetY)*ratio;applyZoom();}gesture=next;
    });
    ['pointerup','pointercancel','lostpointercapture'].forEach(type=>viewport.addEventListener(type,e=>{pointers.delete(e.pointerId);gesture=measure();}));
    viewport.addEventListener('dblclick',()=>{scale=scale>1?1:2.5;offsetX=offsetY=0;applyZoom();});
    viewport.addEventListener('wheel',e=>{e.preventDefault();scale=Math.max(1,Math.min(4,scale*Math.exp(-e.deltaY*.002)));applyZoom();},{passive:false});
    window.addEventListener('resize',()=>{if(dialog.open)applyZoom();});
    host.querySelectorAll('[data-aop-garment]').forEach(button=>button.addEventListener('click',()=>{
      host.querySelectorAll('[data-aop-garment]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));render();
    }));
    host.querySelectorAll('.s23-size-grid input').forEach(input=>input.addEventListener('change',()=>{host.querySelector('.s23-size-status').textContent='';}));
    label();
    return {label,matchingPreview,async snapshot(){await render();if(canvas.hidden)throw new Error(viewer.dataset.error);const thumb=document.createElement('canvas');thumb.width=thumb.height=900;const thumbCtx=thumb.getContext('2d');thumbCtx.fillStyle='#faf9f6';thumbCtx.fillRect(0,0,900,900);thumbCtx.drawImage(canvas,0,0,900,900);return new Promise((resolve,reject)=>thumb.toBlob(b=>{thumb.width=thumb.height=1;b?resolve(b):reject(new Error(viewer.dataset.error));},'image/jpeg',0.85));},texture(source){artCtx.clearRect(0,0,size,size);artCtx.drawImage(source,0,0,size,size);ready=true;render();},invalidate(){if(dialog.open)closePreview();openButton.hidden=true;revision++;ready=false;canvas.hidden=true;status.hidden=false;status.textContent=viewer.dataset.stale;}};
  };
})();






